<template>
  <ion-content>
    <section class="section  bg-transparent novi-background" data-preset='{"title":"Alert Sample","category":"sample","reload":false,"id":"alert-sample"}'>
      <div class="container">
        <div class="row novi-disabled">
          <div class="col">
            <!-- Alert-->
            <div class="alert alert-info">
              <div class="alert-inner">
                <div class="alert-inner-item">
                  <h5 class="alert-title"><span class="icon alert-icon novi-icon int-info"></span>Create an Account!</h5>
                  <div class="alert-text">Create an secure account with us to communicate and to get further information</div>
                </div>
                <div class="alert-inner-item">
                  <div class="alert-inner-controls row">
                    <div class="form-group col">
                      <label for="input-styles1" class="small">Password</label>
                      <div class="position-relative">
                        <input class="form-control form-control-sm" id="input-styles1" type="password" v-model="password" placeholder="6 characters">
                      </div>
                    </div>
                    <div class="col">
                      <label for="input-styles1" class="small"></label>
                      <button class="btn btn-info" v-on:click="signUp()">Signup</button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="alert alert-warning" v-if="passwordInvalid">
              <div class="alert-inner">
                <div class="alert-inner-item">
                  <h6 class="alert-title"><span class="icon alert-icon novi-icon int-warning"></span>Password ling must be 6 characters or more </h6>
                </div>
                <div class="alert-inner-item">
                  <div class="alert-inner-controls">
                    <button class="link link-warning" v-on:click="passwordInvalid = false">Dismiss</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert alert-warning" v-if="authErrorType">
              <div class="alert-inner">
                <div class="alert-inner-item">
                  <h6 class="alert-title"><span class="icon alert-icon novi-icon int-warning"></span>Account Creation Failed</h6>
                  <div class="alert-text" v-if="authErrorType === 'UsernameExistsException'">An account with the given email already exists. Please sign-in. If you forgot the password use password recovery options </div>
                </div>
                <div class="alert-inner-item">
                  <div class="alert-inner-controls">
                    <a v-if="authErrorType === 'UsernameExistsException'" class="btn btn-warning" href="/account/">Login</a>
                    <button class="link link-warning" v-on:click="authErrorType = null">Dismiss</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <program-list :results="(result.results || {}).qualified || []"
                  :selected-program="selectedProgram"
                  :is-qualified="true"
                  :has-qualified-results="((result.results || {}).qualified || []).length > 0"
                  @program="selectProgram($event)"></program-list>

    <program-list :results="(result.results || {}).possible || []"
                  :selected-program="selectedProgram"
                  :is-qualified="false"
                  :has-qualified-results="((result.results || {}).qualified || []).length > 0"
                  @program="selectProgram($event)"></program-list>

    <section v-if="!result.results || ((result.results.qualified || [] ).length === 0 && (result.results.possible || [] ).length === 0 ) "
             class="section section-lg bg-transparent novi-background"
             data-preset='{"title":"Blurb Sample","category":"blurb","reload":false,"id":"blurb-sample-5"}'>
      <div class="container">
        <h4 class="text-center">Our evaluation rules do not produce matching programs for your details. Our expert team
          can help you to find other options. We may also can advice you on how to get your qualifications improved to
          suite the available Visa programs.</h4>
        <h4 class="text-center">Please use the <a class="link link-success" href="contact-us.html">Contact Us</a> form
          to submit your details. one of our qualified member of staff will contact you as soon as possible.</h4>
      </div>
    </section>
  </ion-content>
</template>

<script>
// import Vue from 'vue'
import {Auth} from 'aws-amplify';
import EoppService from "@/mixins/EoppService";
import router from "@/enrol/Router";
import ProgramList from "@/components/ProgramList";
import {IonContent} from "@ionic/vue";

export default {
  name: 'Opportunities',
  mixins: [EoppService],
  components: {
    ProgramList,
    IonContent
  },
  data() {
    return {
      status: null,
      result: {},
      selectedProgram: null,
      password: null,
      passwordInvalid: false,
      authErrorType: null
    };
  },
  mounted() {
    this.showResults();
  },
  methods: {
    async showResults() {
      if (this.signupInfo) {
        this.result = this.signupInfo;
      } else {
        let resString = localStorage.getItem('eopp-results');
        if (resString) {
          this.result = JSON.parse(resString);
          this.$store.commit('signupInfo', this.result);
        } else {
          /**
           * if results not found, go to evaluation page
           */
          await router.push({path: '/quiz'})
        }
      }
      console.log(this.result);
    },
    selectProgram(prog) {
      console.log(this.result)
      if ( this.result.results && this.result.results.crmRec ) {
        if ( this.result.results.crmRec.cf.pref_program !== prog.code ) {
          this.result.results.crmRec.cf.pref_program = prog.code;
          this.selectedProgram = prog;

          this.updateCrmRecord([this.result.results.crmRec],null).then( res => {
            this.status = 'SUCCESS';
            console.log(res);
            setTimeout(() => {
              this.status = null;
            }, 2000);
          });
        }
      }
    },
    async signUp() {
      if ( !this.password || this.password.length < 6){
        this.passwordInvalid = true;
      } else if (this.result) {
        try {
          const {user} = await Auth.signUp({
            username: this.result.email,
            password: this.password,
            attributes: {
              given_name : this.result.first_name,
              family_name : this.result.last_name,
              email: this.result.email
            }
          });
          console.log(user);

          if ( user ){
            try {
              await Auth.signIn(this.result.email, this.password);
              window.location.href = '/account/'
            } catch (error) {
              console.log('error signing in', error);
            }
          } else {
            window.location.href = '/account/#/signup';
          }
        } catch (error) {
          console.log('error signing up:', error);
          console.log( error.code);

          if ( error ){
            this.authErrorType = error.code;
          }
          window.location.href = '/account/#/signup';
        }
      } else {
        window.location.href = '/account/#/signup'
      }
    },
    submit: async function () {
      console.log(this.user);

      this.status = this.user.name && this.user.email && this.user.message ? 'VALID' : 'INVALID';

      const token = await this.recaptcha();

      if (this.status === 'VALID') {
        // this.postContactUs(this.user, token );
        this.postContactUs(this.user, token).then(res => {
          console.log(res);
          if ((res || {}).data === 'SUCCESS') {
            this.status = 'SUCCESS';
            this.user = {};
          }
        });
      }
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      // await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      // const token = await this.$recaptcha('login')

      // return token;
      // Do stuff with the received token.
    }
  }
}
</script>

<style>

@media only screen and (min-width: 992px) {
  ion-app {
    max-width: 90%;
    margin: 4em auto 2px;
  }
}

@media only screen and (max-width: 1023px) {
  ion-app {
    max-width: 100%;
    margin: 4em auto 6em;
  }
}

.program {
  cursor: pointer;
}

.selected-program {

}

.selected-program.icon {
  /*width: 200px;*/
  /*background: #e43;*/
  position: absolute;
  top: 2%;
  left: 8%;
  font-size: xx-large;
  /*text-align: center;*/
  /*line-height: 50px;*/
  /*letter-spacing: 1px;*/
  color: #2c7;
  /*transform: rotate(-45deg);*/
  /*-webkit-transform: rotate(-45deg);*/
}

@media (min-width: 768px) {
  .article-box-large {
    min-height: 22em;
  }
  .article-box-small {
    min-height: 15em;
  }
}
</style>
